// extracted by mini-css-extract-plugin
export default {"errorMessage":"ResetView-module__errorMessage--OMDgt","animatedBackground":"ResetView-module__animatedBackground--6-+41"};